import {useEffect, useState, useRef, forwardRef, useImperativeHandle, Fragment} from 'react'
import {flushSync} from 'react-dom'
import style from './index.module.less'
import {Input,Tooltip, message} from 'antd';
import {
    CARD_HIGHLIGHT_COLOR,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_PDF_ANNO_COMMENT,
    EVENT_SAVE_CARD,
    EVENT_TEST_ONDRAG_NOTE, KEY_FILE_DIR, MAX_Z_INDEX,
    usedColorToShowColor
} from "@/Const";
import {
    copyTextToClipboard,
    createCopyLink,
    getImagePathWithTheme,
    getImagePathWithThemeSvg, getString,
    getSvgHeight, isInDraw,
    sleep
} from '@/utils';
import RightMenu from '@/components/RightMenu'
import {Await} from "react-router";
import {batchCardHighlight, batchUpdateCard, getCardById, updateCard} from "@model/card";
import {detectNodeTypeArr, getAllHighlightContent} from "@/Utility0";
import {t} from "i18next";
import {postMessage} from "@/common/event";
import {copyTextToSystemClipboard, copyToClipboard} from "../../../../@excalidraw/packages/excalidraw/clipboard";
import {isMac} from "@/Utility";
import global from "@/global";
import {imgServer} from "@/components/EditorV2/imgServer";
import {KEYS} from "../../../../@excalidraw/packages/excalidraw/keys";
import {IconCopyLink, IconCopyText, IconDelete, IconInfoMenu, IconManagerTags} from "@/Icon";
import {isWeb} from "@/electron_interactive";
import {ipcInvoke} from "@/common/ipc";


const {TextArea} = Input;

const HighlightBar = forwardRef((props:{editor:any,data:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onRefreshHighlight:refreshHighlight,
        onRemoveSelectedHighlight:onRemoveSelectedHighlight
    }))
    const {editor,data} = props;
    const [showSearchInput, setShowSearchInput] = useState<boolean>(false)
    const [allHighlightContent, setAllHighlightContent] = useState<Array<object>>([])
    const [highlightContent, setHighlightContent] = useState<Array<object>>([])
    const [inputValue, setInputValue] = useState('');
    const [colorOption, setColorOption] = useState<Array<Object>>([])
    const searchRef = useRef(null);
    const searchInputRef = useRef(null);
    const highlightRefs = useRef([]);
    const [contentHeight,setContentHeight] = useState(0);

    const highlightContentRef = useRef(highlightContent);
    const [headings, setHeadings] = useState([])
    const mCurrentSelectIndex = useRef(-1);
    const mDoubleClickedIndex = useRef<any>(-1);

    useEffect(() => {
        highlightContentRef.current = highlightContent;
    }, [highlightContent]);

    // 点击空白区域
    const handleOutsideClick = (event) => {
        // 若有编辑状态则退出
        // 点击除了自身highLightItem之外的

        let ifEdit
        let ifSelected
        setHighlightContent(prevState => {
            for (let i = 0; i < prevState.length; i++) {
                if (prevState[i].editStatus) {
                    ifEdit = i
                }
                if (prevState[i].selectStatus) {
                    ifSelected = i
                }
            }

            //   对item选中状态进行重置
            if (ifSelected !== undefined && !highlightRefs.current[ifSelected].contains(event.target)){
                prevState[ifSelected].selectStatus = false
            }


            if (ifEdit !== undefined && !highlightRefs.current[ifEdit].contains(event.target)) {
                // 触发空白事件1
                prevState[ifEdit].editStatus = false
            } else {
                //  全局重置搜索内容
                setShowSearchInput(prevState => {
                    // 点击颜色选择按钮应该要被排除在外
                    //  highlight item  也应该被排查在外
                    const isInsideHighlightArray = highlightRefs.current.some((highlightRef) =>
                        highlightRef?.contains(event.target)
                    );

                    if (prevState && searchRef.current && !searchRef.current.contains(event.target) && !event.target.classList?.[0]?.includes('colorItem') && !isInsideHighlightArray) {
                        prevState = false
                        // 全局搜索重置
                        setAllHighlightContent((prev) => {
                            prev = prev.map(item => {
                                item.selectStatus = false;
                                return item
                            })
                            setHighlightContent(prev)
                            setColorOption((prev) => {
                                let newItems = [...prev];
                                newItems.map(item => {
                                    item.selectStatus = false;
                                    return item
                                })
                                return newItems;
                            })
                            setInputValue('')
                            return prev;
                        });
                    }
                    return prevState
                })
            }
            return [...prevState]
        })

    }

    // 滚动
    const handleNavigate = (event) => {
        let nDelay = 100;
        if (highlightContentRef.current?.length == 0){
            nDelay = 300;
        }

        setTimeout(()=>{
            const targetIndex = highlightContentRef.current.findIndex(highlight => highlight.id === event.detail.id);
            if (targetIndex !== -1 && highlightRefs.current[targetIndex]) {
                // 更新选中状态
                setHighlightContent(prevState => {
                    return prevState.map((item, i) => ({
                        ...item,
                        selectStatus: i === targetIndex
                    }));
                });

                setTimeout(()=>{
                    // 滚动到对应位置
                    highlightRefs.current[targetIndex].scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                },200)

                //滚动笔记的位置.
                const highlight = highlightContentRef.current.find(p=>p.id == event.detail.id);
                if (highlight){
                    const domNode = editor.view.nodeDOM(highlight.pos);
                    domNode.parentNode.scrollIntoView({
                        // behavior: 'smooth',
                        block: 'center'
                    })
                }

            }
        },nDelay);
    }

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
        handleInputEnter(event);
    };
    const handleInputEnter = (event) => {
        setColorOption((prevItems) => {
            let newItems = [...prevItems];
            // 对当前内容进行过滤
            const selectedColorArr = newItems.filter(item => item.selectStatus)
                .map(item => item.color);
            searchHighlight(event.target.value, allHighlightContent, selectedColorArr)
            return newItems;
        });
    };

    // 搜索前把所有选中highlight重置
    function searchHighlight(keyword, highlightSource, selectedHighlightArr = []) {
        let searchResult = highlightSource.filter(item => {
            return ((item.content.includes(keyword) || String(item.noteText)?.includes(keyword)) && (selectedHighlightArr.length == 0 || selectedHighlightArr.includes(item.color)))
        })
        if (selectedHighlightArr.length === 0) {
            setColorOption((prev) => {
                let newItems = [...prev];
                newItems.map(item => {
                    item.selectStatus = false;
                    return item
                })
                return newItems;
            })
        }
        setHighlightContent(searchResult)
    }

    const refreshHighlight = () => {
        const highlights = getAllHighlightContent(editor);
        setAllHighlightContent(highlights.content);
        setColorOption(prevState => {
            const newColorArr = ColorPreprocess(prevState, highlights.colorArr)
            const selectedColorArr = newColorArr.filter(item => item.selectStatus)
                .map(item => item.color);
            searchHighlight(inputValue, highlights.content, selectedColorArr)
            return newColorArr
        })
    }

    /**
     * 移除选中的高亮，如果有的话...
     */
    const onRemoveSelectedHighlight = ()=>{
        const highlight = allHighlightContent.find(p=>p.selectStatus);
        if (highlight){
            // alert('xxx')
        }
    }

    const intoNoteEditStatus = (e, index) => {
        if (global.g_isPresentMode){
            message.error(t("PreviewModeNotSupport"));
            return;
        }
        e.stopPropagation()
        mDoubleClickedIndex.current = index;

        setHighlightContent(prevState => {
            prevState[index].editStatus = true
            return prevState
        })

        setTimeout(()=>{
            const arrayTxtArea = highlightRefs.current[index].querySelectorAll('textarea');
            if (arrayTxtArea.length > 0){
                arrayTxtArea[0].focus();
            }
        },200)
    }

    const focusTxt = (index)=>{
        const arrayTxtArea = highlightRefs.current[index].querySelectorAll('textarea');
        if (arrayTxtArea.length == 0){
            setTimeout(focusTxt,100,index);
        }
    }
    const jumpHighlight = async (pos, end, index) => {
        // 优先展开
        if (mCurrentSelectIndex.current != index)
        {
            const { state, view } = props.editor
            const editor = props.editor
            const headings: any[] = []
            let l1El = 0,
                l2El = 0,
                l3El = 0,
                l4El = 0,
                l5El = 0,
                l6El = 0,
                pId = '',
                index = 0;
            editor.state.doc.descendants((node, pos) => {
                if (node.type.name === 'heading') {
                    if (node.attrs["level"] < 7) {

                        let elP = 0
                        if (node.attrs["level"] === 1) {
                            l1El++
                            elP = l1El
                            // if(l1El === 1) return
                            // pId = node.textContent + l1El + l2El
                        } else if (node.attrs["level"] === 2) {
                            l2El++
                            elP = l2El
                        } else if (node.attrs["level"] === 3) {
                            l3El++
                            elP = l3El
                        } else if (node.attrs["level"] === 4) {
                            l4El++
                            elP = l4El
                        } else if (node.attrs["level"] === 5) {
                            l5El++
                            elP = l5El
                        } else {
                            l6El++
                            elP = l6El
                        }

                        let top = document.querySelectorAll(`.ProseMirror h${node.attrs["level"]}`)[elP - 1]?.offsetTop
                        headings.push({
                            index,
                            text: node.textContent,
                            level: node.attrs["level"],
                            id: node.textContent + '_id_' + l1El + l2El + l3El + l4El + l5El + l6El,
                            // id: '_id_' +l1El + l2El + l3El,
                            pos: pos,
                            elP: elP - 1,  // 元素位置
                            top,
                            dataId: node.attrs["id"],
                            ifFold: node.attrs["fold"],
                            attrs: node.attrs,
                            ifClick: false
                        })
                        index++
                    }
                }
            })

            /** 优化后的pId计算 */
            function calculateParentIds(headings) {
                // 使用栈来跟踪每个层级的最新父节点
                const parentStack = new Array(7).fill(null); // 支持1-6级标题

                for (let i = 0; i < headings.length; i++) {
                    const current = headings[i];
                    const level = current.level;

                    // 更新当前层级的节点
                    parentStack[level] = current;

                    // 清空比当前层级更深的所有层级
                    for (let j = level + 1; j < 7; j++) {
                        parentStack[j] = null;
                    }

                    // 寻找父节点：从当前层级-1开始向上查找
                    let parentId = '';
                    for (let parentLevel = level - 1; parentLevel >= 1; parentLevel--) {
                        if (parentStack[parentLevel]) {
                            parentId = parentStack[parentLevel].id;
                            break;
                        }
                    }

                    current.pId = parentId;
                }

                return headings;
            }

            // 应用优化后的计算
            calculateParentIds(headings);

            let item
            for (let i = headings.length - 1; i >= 0; i--) {
                if (headings[i].pos < pos) {
                    item = headings[i]
                    break;
                }
            }
            // debugger

            if (item) {
                let tr
                let parentHeading
                let parentHeadingIndex = item.level === 1 ? -1 : headings.findIndex(heading => heading.id === item.pId);
                // 与目录不同，需要把最近的一级heading展开
                {
                    tr = state.tr.setNodeMarkup(item.pos, state.schema.nodes['heading'], {
                        ...item.attrs,
                        fold: false
                    });
                    // 改变所属节点的隐藏显示状态
                    // 1,确定节点所属部分
                    let foldContentArr = []
                    let startCompute = false
                    state.doc.descendants((node, pos) => {
                        if (node.type.name === 'heading' && node.attrs.id === item.dataId) {
                            startCompute = true;
                        } else if (startCompute && node.type.name !== 'text') {
                            if (node.type.name !== 'heading' || (node.type.name === 'heading' && node.attrs.level > item.level)) {
                                foldContentArr.push({
                                    node: node,
                                    pos: pos
                                })
                            } else {
                                startCompute = false;
                            }
                        }
                    });
                    // 2,改变节点所属部分的显示状态
                    foldContentArr.forEach((ele) => {
                        const attrs = {
                            ...ele.node.attrs,
                            ifhidden: false
                        }
                        if (ele.node.type.name === 'heading') {
                            attrs.fold = false
                        }
                        tr.setNodeMarkup(ele.pos, state.schema.nodes[`${ele.node.type.name}`], attrs);
                    })
                }
                while (parentHeadingIndex !== -1) {
                    parentHeading = headings[parentHeadingIndex]
                    if (parentHeading.ifFold) {
                        // 改变图标的状态
                        // const selectNodeNP = editor.$doc.querySelectorAll('heading', { id: parentHeading.dataId })[0]
                        // debugger
                        tr = state.tr.setNodeMarkup(parentHeading.pos, state.schema.nodes['heading'], {
                            ...parentHeading.attrs,
                            fold: false
                        });
                        // 改变所属节点的隐藏显示状态
                        // 1,确定节点所属部分
                        let foldContentArr = []
                        let startCompute = false
                        state.doc.descendants((node, pos) => {
                            if (node.type.name === 'heading' && node.attrs.id === parentHeading.dataId) {
                                startCompute = true;
                            } else if (startCompute && node.type.name !== 'text') {
                                if (node.type.name !== 'heading' || (node.type.name === 'heading' && node.attrs.level > parentHeading.level)) {
                                    foldContentArr.push({
                                        node: node,
                                        pos: pos
                                    })
                                } else {
                                    startCompute = false;
                                }
                            }
                        });
                        // 2,改变节点所属部分的显示状态
                        foldContentArr.forEach((ele) => {
                            const attrs = {
                                ...ele.node.attrs,
                                ifhidden: false
                            }
                            if (ele.node.type.name === 'heading') {
                                attrs.fold = false
                            }
                            tr.setNodeMarkup(ele.pos, state.schema.nodes[`${ele.node.type.name}`], attrs);
                        })
                        // tr = tr.setNodeMarkup(paragraphNP.pos - 1, schema.nodes.paragraph, {
                        //   ...paragraphNP.attributes,
                        //   ifhidden: !paragraphNP.attributes.ifhidden
                        // });
                    }
                    parentHeadingIndex = parentHeading.level === 1 ? -1 : headings.findIndex(heading => heading.id === parentHeading.pId);
                }
                if (tr) {
                    view.dispatch(tr);
                }
            }
        }

        mCurrentSelectIndex.current = index;

        setTimeout(async ()=>{
            const boundingRect = editor.view.coordsAtPos(pos);
            const scrollTop = editor.view.dom.parentElement.parentElement.parentElement.scrollTop;
            const clientHeight = document.documentElement.clientHeight;
            const targetScroll = scrollTop + boundingRect.top - clientHeight / 2;

            if (isInDraw() && global.g_isPresentMode){
                editor.view.dom.setAttribute('contenteditable', 'true');
                editor.view.dom.focus();
            }


            editor.chain().focus().setTextSelection({from: pos, to: end}).run();
            await sleep(50)
            setHighlightContent(prevState => {
                prevState.map((item, i) => {
                    if (index === i) {
                        item.selectStatus = true
                    } else {
                        item.selectStatus = false
                    }

                    if (i == mDoubleClickedIndex.current){
                        item.editStatus = true
                    }

                    return item
                })
                return [...prevState]
            })
            await sleep(50)
            editor.view.dom.parentElement.parentElement.parentElement.scrollTo({
                top: targetScroll,
                behavior: 'smooth',
            });

            //移除焦点
            if (isInDraw() && global.g_isPresentMode){
                editor.view.dom.setAttribute('contenteditable', 'false');
            }

            mDoubleClickedIndex.current = -1;
        },150)
    }
    const moreOptions = async (event, highlight, leftmenu = false) => {
        if (leftmenu) {
            return;
        }
        event.stopPropagation();
        const menus = [
            {
                label: t('Copy text'),
                key: 'Copy text',
                icon:<IconCopyText/>
            },
            {
                label: t('Copy link'),
                key: 'Copy link',
                icon:<IconCopyLink/>
            },
            {
                label:t("Show info"),
                key:'showInfo',
                icon:<IconInfoMenu/>
            },
            {
                label:t("Manage tags"),
                key:'manageTags',
                icon:<IconManagerTags/>
            },

            {
                label: t('Delete'),
                key: 'delete',
                icon:<IconDelete/>
            }
        ]
        const key = await RightMenu.open(event.pageX, event.pageY, menus)
        if (key === 'Copy text') {
            let szNote = '';
            if (highlight.noteText){
                szNote = '\n' + t("Note")+":"+highlight.noteText
            }
            copyTextToSystemClipboard(highlight.content + szNote);
        }
        else if (key === 'Copy link') {
            // let highLightAdress = `noteeditor://open?note=${sessionStorage.getItem("note-id")}&&blockid=${highlight.node.attrs.id}&&blocktype=highlight`
            // window.IPC.textToCopy(highLightAdress)
            createCopyLink('library',highlight.id,'cardAnno');
        }
        else if (key == 'manageTags'){
            getCardById(highlight?.id)?.then(res=>{
                window.showManageTags([res]);
            })
        }else if (key == 'showInfo'){
            getCardById(highlight?.id).then(res=>{
                window.showInfo('library',res);
            })
        }
        else if (key === 'delete') {
            if (detectNodeTypeArr.includes(highlight.type)) {
                // const resolvedPos = window?.GEditor.state.doc.resolve(highlight.pos);
                // const currentNode = resolvedPos.node(resolvedPos.depth);
                // currentNode.attrs = { ...currentNode.attrs, blockHighlight: false }
                highlight.node.attrs = {...highlight.node.attrs, blockHighlight: false}
            }

            if (highlight.type == 'image'){
                const selectedNP = editor.$doc.querySelectorAll(highlight.type, {id: highlight.id})[0]
                selectedNP.node.attrs.highlightImgUrl = ""
                document.dispatchEvent(new CustomEvent('changeHighlight'));
                document.dispatchEvent(new CustomEvent('refreshSidebar'));
            }else{
                editor
                    .chain()
                    .focus()
                    .setTextSelection({from: highlight.pos, to: highlight.end})  // 设置文本选择范围
                    .unsetHighlight()
                    .run();
            }

            setTimeout(async ()=>{
                await saveDataToDB();
                const highlights = getAllHighlightContent(editor);
                batchCardHighlight(highlights.content,data?.id,data?.name).then(res=>{
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                });
            },200)
        }
    }
    const moreOptionsForPicture = async (event, highlight, leftmenu = false) => {
        if (leftmenu) {
            return;
        }
        event.stopPropagation();
        const menus = [
            {
                label: t('Copy link'),
                key: 'Copy link',
            },
            {
                label: t('Delete'),
                key: 'delete'
            }
        ]
        const key = await RightMenu.open(event.pageX, event.pageY, menus)
        if (key === 'Copy link') {
            // let highLightAdress = `noteeditor://open?note=${sessionStorage.getItem("note-id")}&&blockid=${highlight.node.attrs.id}&&blocktype=${highlight.type}`
            // window.IPC.textToCopy(highLightAdress)
            createCopyLink('library',highlight.id,'cardAnno');
        }
        if (key === 'delete') {
            const selectedNP = editor.$doc.querySelectorAll(highlight.type, {id: highlight.id})[0]
            selectedNP.node.attrs.highlightImgUrl = ""
            document.dispatchEvent(new CustomEvent('changeHighlight'));
            document.dispatchEvent(new CustomEvent('refreshSidebar'));

            setTimeout(async ()=>{
                await saveDataToDB();
                const highlights = getAllHighlightContent(editor);
                batchCardHighlight(highlights.content,data?.id,data?.name).then(res=>{
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                });
            },200)
        }
    }

    // 复制所有标注到剪贴板（支持富文本格式）
    const copyAllHighlights = async () => {
        if (highlightContent.length === 0) {
            return;
        }

        let textResult = "";
        let htmlResult = "<div style='font-family: Arial, sans-serif; line-height: 1.6;'>";

        // 异步处理所有标注
        for (let index = 0; index < highlightContent.length; index++) {
            const highlight = highlightContent[index];

            // 判断是否为图片类型
            const isImage = highlight.type === "image" ||
                highlight.type === "youtube" ||
                highlight.type === "latexBlock";

            if (isImage) {
                // 文本格式 - 序号和图片标注在同一行
                textResult += `${index + 1}.\n[Picture]`;

                // HTML 格式 - 序号用 p 标签包裹
                htmlResult += `<p style='font-size: 16px;'>${index + 1}.</p>`;

                // 处理 atom:// 协议的图片
                let imgSrc = highlight.content;
                if (imgSrc.startsWith('atom://')) {
                    try {
                        // 提取 ID 和扩展名
                        const lastDotIndex = imgSrc.lastIndexOf('.');
                        const id = imgSrc.slice(7, lastDotIndex);
                        const ext = imgSrc.slice(lastDotIndex + 1); // 获取扩展名 (jpeg, png, etc.)

                        // 从数据库获取 Base64 数据
                        let base64Data ;//= await model.getImgById(id);
                        const filePath = localStorage.getItem(KEY_FILE_DIR)+id+'.'+ext;
                        base64Data = 'data:image/png;base64,' + await ipcInvoke('read-file-base64',{filePath:filePath});

                        // 检查是否已经包含 Data URL 前缀
                        if (!base64Data.startsWith('data:')) {
                            // 根据扩展名添加正确的 MIME 类型
                            const mimeType = ext === 'png' ? 'image/png' :
                                ext === 'jpg' || ext === 'jpeg' ? 'image/jpeg' :
                                    ext === 'gif' ? 'image/gif' :
                                        ext === 'webp' ? 'image/webp' :
                                            'image/png'; // 默认使用 png

                            base64Data = `data:${mimeType};base64,${base64Data}`;
                        }

                        imgSrc = base64Data;
                    } catch (error) {
                        console.error('Failed to get image data:', error);
                        // 如果获取失败，使用占位文本
                        imgSrc = '';
                    }
                }

                if (imgSrc) {
                    htmlResult += `<p><img src="${imgSrc}" style="max-width: 600px; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"/></p>`;
                }

                // 如果有评论，添加评论（保留换行符转为 <br/>）
                if (highlight.noteText) {
                    const noteTextStr = String(highlight.noteText);
                    if (noteTextStr.trim()) {
                        const noteTextEscaped = noteTextStr
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;')
                            .replace(/\n/g, '<br/>');

                        textResult += `\nNote：${noteTextStr}`;
                        htmlResult += `<p style='color: #666;'>Note：${noteTextEscaped}</p>`;
                    }
                }
            } else {
                // 文本标注 - 序号和内容用 p 标签包裹
                const contentEscaped = highlight.content
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/\n/g, '<br/>');

                textResult += `${index + 1}.\n${highlight.content}`;
                htmlResult += `<p style='font-size: 16px;'>${index + 1}.</p>`;
                htmlResult += `<p style='border-left: 3px solid #4a90e2; padding-left: 12px;'>${contentEscaped}</p>`;

                // 如果有评论，添加评论（保留换行符转为 <br/>）
                if (highlight.noteText) {
                    const noteTextStr = String(highlight.noteText);
                    if (noteTextStr.trim()) {
                        const noteTextEscaped = noteTextStr
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;')
                            .replace(/\n/g, '<br/>');

                        textResult += `\nNote：${noteTextStr}`;
                        htmlResult += `<p style='color: #666;'>Note：${noteTextEscaped}</p>`;
                    }
                }
            }

            // 只在项目之间添加空行（除了最后一个）
            if (index < highlightContent.length - 1) {
                textResult += "\n\n";
                htmlResult += "<p>&nbsp;</p>"; // HTML 格式的空行
            }
        }

        htmlResult += "</div>";

        // 同时复制文本和 HTML 格式到剪贴板
        window.IPC.richContentToCopy({
            text: textResult,
            html: htmlResult
        });

        // 显示成功提示
        message.success(t("CopiedAllToText"));
    };

    const noteTextchange = (e, index, highlight) => {
        e.stopPropagation();
        // 不仅要改变当前的highlight，也要改变源头的highlight
        setHighlightContent(prevState => {
            prevState[index].noteText = e.target.value;
            return [...prevState]
        })
        setAllHighlightContent(prevState => {
            for (let i = 0; i < prevState.length; i++) {
                if (prevState[i].id === highlightContent[index].id) {
                    prevState[i].noteText = e.target.value;
                    break
                }
            }
            return [...prevState]
        })
        // 改变mark里的东西
        highlight.node.attrs.noteText = e.target.value;

        //更新到数据库
        getCardById(highlight.id)?.then((res:any)=>{
            if (res){
                res.comment = e.target.value;
                res.updateTime = Date.now();
                updateCard(res);

                //刷新画布上的.
                postMessage(EVENT_REFRESH_PDF_ANNO_COMMENT,{annotations:[res],fileId:res.libraryId})
            }
        })

        //更新实际的card
        postMessage(EVENT_SAVE_CARD,{id:props.data.id});
    }

    const exitNoteEditStatus = (e, index) => {
        if (e.key === "Escape") {
            setHighlightContent(prevState => {
                prevState[index].editStatus = false
                return [...prevState]
            })
            e.stopPropagation();
        }
    }
    const ColorPreprocess = (oldData, newData) => {
        const oldDataMap = new Map(oldData.map(item => [item.color, item.selectStatus]));
        const newArr = []
        newData.forEach(item => {
            if (oldDataMap.has(item)) {
                newArr.push({
                    color: item,
                    selectStatus: oldDataMap.get(item)
                })
            } else {
                newArr.push({
                    color: item,
                    selectStatus: false
                })
            }
        });
        return newArr
    }
    const colorChoose = (e, item, index) => {
        e.stopPropagation()
        setColorOption((prevItems) => {
            let newItems = [...prevItems];
            newItems[index] = {...newItems[index], selectStatus: !newItems[index].selectStatus};
            // 对当前内容进行过滤
            const selectedColorArr = newItems.filter(item => item.selectStatus)
                .map(item => item.color);
            searchHighlight(inputValue, allHighlightContent, selectedColorArr)
            return newItems;
        });
    }


    const waitViewOk = (nPos)=>{
        return new Promise(resolve => {
            setTimeout(()=>{
                if (editor?.view?.docView){
                    try{
                        editor.view.coordsAtPos(nPos);
                        resolve('ok');
                    }catch (e) {
                        resolve('no');
                    }
                }else{
                    resolve('no');
                }
            },100)
        })
    }

    const editViewOk = async (nPos)=>{
        for (let i=0;i<20;i++){
            const szOk = await waitViewOk(nPos);
            if (szOk == 'ok'){
                return 'ok';
            }
        }
    }

    /**
     * 保存到数据库
     */
    const saveDataToDB = ()=>{
        //!!!!!这个东西，到处的变量不在一个实例里面。。。
        const html = imgServer.parserImgFromHtml(editor.getHTML() as string);
        const name = props.data?.name;
        let createTime = props.data?.createTime;
        let updateTime = Date.now();
        if (!createTime) {
            createTime = updateTime;
        }
        const data = {
            ...(props.data || {}),
            doc: html,
            type: props.data?.type || 'card',
            name: name || '',
            createTime,
            updateTime
        };
        if (data.id){
            updateCard(data);
        }
    }

    useEffect(() => {
        window.cancelHeightbar = ()=>{
            const item = highlightContent.find(p=>p.selectStatus);
            if (item){
                //有选中的..
                const arrayNew = [...highlightContent];
                item.selectStatus = false;
                setHighlightContent(arrayNew);
                editor.commands.blur();
                return true;
            }
            return false;
        }

        return ()=>{
            delete window.cancelHeightbar;
        }
    });

    useEffect(() => {

        window.onRefreshHighlight = ()=>{
            refreshHighlight();
        }

        const handleUpdate = () => {
            setTimeout(()=>{
                //在highlight显示的情况下，如果不延迟，这里刷新的--getAllHighlightContent 获取的highlightid 和 别的地方不一样，不一样不一样不一样不一样不一样不一样不一样不一样不一样
                refreshHighlight()
            },160);

        }
        // window.GEditor.on("selectionUpdate", handleUpdate)
        editor.on("update", handleUpdate)

        document.addEventListener('mousedown', handleOutsideClick);
        document.addEventListener('changeHighlight', handleUpdate);
        document.addEventListener('highlightBar-navigate', handleNavigate);

        refreshHighlighBarHeight();

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('changeHighlight', handleUpdate);
            document.removeEventListener('highlightBar-navigate', handleNavigate);
            // window.GEditor.off("selectionUpdate", handleUpdate)
            editor?.off("update", handleUpdate);
            delete window.onRefreshHighlight;
        }
    }, [])

    useEffect(()=>{
        //设置上editor的数据后，再读取高亮数据

        setTimeout(()=>{

            refreshHighlighBarHeight();

            const highlights = getAllHighlightContent(editor);
            setAllHighlightContent(highlights.content);

            const newColorArr = ColorPreprocess(colorOption, highlights.colorArr)
            setColorOption(newColorArr)
            // setColorOption(highlights.colorArr)
            setHighlightContent(highlights.content);


            //有注记，需要转到...
            if (props.data?.annoId){
                setTimeout(()=>{
                    for (let i=0;i<highlights.content.length;i++){
                        const highlight = highlights.content[i];
                        if (highlight.id == props.data.annoId){
                            editViewOk(highlight.pos).then(res=>{
                                jumpHighlight(highlight.pos, highlight.end, i);
                            })
                            break;
                        }
                    }

                    setTimeout(()=>{
                        // setSideBarStatus(2);
                        const divItem = document.getElementById('card-highlight-'+props.data.annoId);
                        if (divItem){
                            divItem.scrollIntoView({ behavior: "auto" });
                        }
                        props.data.annoId = '';
                    },200)
                },300);
            }
        },150)

        if (props.data){
            window.refreshList['refresh_highlightbar_'+props.data.id] = refreshHighlight;
        }

        return ()=>{
            if (props.data){
                delete window.refreshList['refresh_highlightbar_'+props.data.id];
            }
        }

    },[props.data,props.editor])

    useEffect(() => {
        refreshHighlighBarHeight();
    }, [colorOption]);

    const onKeydown = (event:any)=>{
        if (event.key == KEYS.BACKSPACE){
            event.stopPropagation();
        }
    }


    const refreshHighlighBarHeight = ()=>{
        const divHighlightBar = document.getElementById('div-highlight-bar-content');
        if (divHighlightBar){
            let nHeight = divHighlightBar.offsetHeight - 106;
            if (isMac()){
                nHeight = divHighlightBar.offsetHeight - 106;
            }

            if (colorOption.length <= 1){
                nHeight = divHighlightBar.offsetHeight - 52;
            }

            // let nHeight = divHighlightBar.offsetHeight - 42;
            setContentHeight(nHeight);
        }
    }

    /**
     * 复制注记文本.
     */
    const copyHighlightToText = ()=>{
        if (isWeb()){
            const szText = highlightContent.map((p,index)=>{
                let szTxt = `${index+1}.`;
                if (p.type == 'image'){
                    szTxt += `\n[${t('Picture')}]`
                }else if (p.type == 'youtube'){
                    szTxt += '\n[Youtube]'
                }else{
                    szTxt += '\n'+p.content
                }
                if (p.noteText){
                    szTxt += '\n'+t("Note")+": "+p.noteText;
                }
                return szTxt + '\n\n';
            }).join('')
            copyTextToClipboard(szText);
            message.info(t("CopiedAllToText"));
        }else{
            //如果是程序的改为 外包这边实现的》。。
            copyAllHighlights();
        }
    }


    return (
        <div id={'div-highlight-bar-content'} style={{position: 'relative', height: "100%"}}>
            <div className={style.topmenu}>
                <span className={style.text}>{t("Highlights")+' '+(highlightContent.length>0?`(${highlightContent.length})`:'')}</span>
                <div className={'flex-center ' + style.toolIconBar} ref={searchRef}>
                    {
                        showSearchInput ? <Input
                            placeholder={t("Search highlights")}
                            allowClear={true}
                            size='small'
                            style={{marginLeft:'4px',outline:'none',height:'26px'}}
                            className={'input-border'}
                            value={inputValue}
                            onChange={handleInputChange}
                            onPressEnter={handleInputEnter}
                            ref={searchInputRef}
                            prefix={<img className={'img-16 cursor-pointer'} onClick={handleInputEnter} src={getImagePathWithTheme('home_search')}/>}
                        /> : <div className={'flex-row-vertical-center'}><Tooltip zIndex={MAX_Z_INDEX} arrow={false} title={t("CopyAllHighlightsToText")}><img className={'img-20 cursor-pointer'} src={getImagePathWithThemeSvg('highlight_copy.svg')} onClick={()=>{
                            copyHighlightToText();
                        }}/></Tooltip><img className={'img-20 cursor-pointer ml-6 mt-1'} src={getImagePathWithTheme('search_0_0_0.svg')} onClick={async () => {
                            setShowSearchInput(true);
                            await sleep(20);
                            searchInputRef.current?.focus();
                        }}/></div>
                    }

                </div>
            </div>
            <div className={style.content} style={{height:contentHeight+'px'}}>
                {highlightContent.length > 0 &&
                    highlightContent.map((highlight, index) => (highlight.type === 'image' || highlight.type === 'youtube' || highlight.type === 'latexBlock') ?
                        <div draggable={true} id={'card-highlight-'+highlight.id} onKeyDown={(event)=>{
                            onKeydown(event)
                        }}
                             onDragEnd={(event) => {
                                 const dragData = {
                                     id: highlight.id,
                                     type: 'cardAnno',
                                     x: event.clientX,
                                     y: event.clientY
                                 }
                                 postMessage(EVENT_TEST_ONDRAG_NOTE, dragData);
                                 if(window.location.href.endsWith("/card") || window.location.href.endsWith('/journal') || window.location.href.endsWith('/draw')  || window.location.href.endsWith('/defaultProject')) {
                                     global.g_currentDragLibraryItem = {...highlight,type:dragData.type};
                                 }
                             }}
                            key={highlight.listId}
                             ref={el => {
                                 highlightRefs.current[index] = el
                             }}
                             style={{
                                 border: '1px solid var(--box-shadow-border)',
                                 borderRadius: '8px',
                                 padding: '12px',
                                 overflow:'hidden',
                                 boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                 margin: '15px 0px',
                                 backgroundColor: highlight.selectStatus ? `var(--select-background-color)` : 'var(--dialog-dialog-background-color)',
                                 outline: highlight.selectStatus ? '1px solid rgba(161, 179, 228)' : 'none'
                             }} onClick={async () => {
                                //  const div = document.getElementById('card-highlight-'+highlight.id);
                                //  div?.focus();
                                // setHighlightContent(prevState => {
                                //     prevState.map((item, i) => {
                                //         if (index === i) {
                                //             item.selectStatus = true
                                //         } else {
                                //             item.selectStatus = false
                                //         }
                                //         return item
                                //     })
                                //     return [...prevState]
                                // })
                                // await sleep(50)
                                // const selectedNP = editor.$doc.querySelectorAll(highlight.type, {id: highlight.id})[0]
                                // editor.chain().focus().setNodeSelection(selectedNP.pos).scrollIntoView({block: 'center'}).run();

                                jumpHighlight(highlight.pos, highlight.end, index)
                        }}
                             onContextMenu={(e) => moreOptionsForPicture(e, highlight)}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <span className={'flex-center'} style={{
                                    border: `1.6px solid ${usedColorToShowColor(highlight.color)}`,
                                    color: usedColorToShowColor(highlight.color),
                                    fontSize: '11px',
                                    width: '18px', height: '18px',
                                    fontWeight: '700',
                                    borderRadius: '1.5px'
                                }}>A</span>
                                {
                                    !global.g_isPresentMode &&
                                    <img className={'img-16 cursor-pointer'} src={getImagePathWithTheme('v_more_right')}
                                         onClick={(e) => moreOptions(e, highlight)}/>
                                }

                            </div>
                            <div style={{
                                width: 'calc(100% + 40px)',
                                height: '1px',
                                borderTop: '1px solid var(--line-color)',
                                margin: '8px -20px'
                            }}></div>

                            <img src={highlight.content} style={{
                                width: '100%',
                                marginTop: '5px'
                            }}/>
                            <div style={{marginTop: '12px', color: 'var(--text-color)', fontSize: '12px'}}>{
                                highlight.editStatus ?
                                    <TextArea className={'input-white-background input-blue-border'} style={{resize: 'none',fontSize:'12px',border:'none',color:'black',}}
                                              autoSize={{minRows: 1}}
                                              value={highlight.noteText}
                                              // readOnly={global.g_isPresentMode}
                                              onClick={e => e.stopPropagation()}
                                              onChange={e => noteTextchange(e, index, highlight)}
                                              onKeyDown={e => exitNoteEditStatus(e, index)}
                                              placeholder={t("Add card note")}/>
                                    :
                                    <div
                                        className={highlight.selectStatus?style.showStatusNoLine:style.showStatus}
                                        style={{height: highlight.noteText ? 'none' : '32px', paddingTop: '5px',fontSize:'12px'}}
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            if (e.detail === 1) {
                                                setTimeout(() => {
                                                    jumpHighlight(highlight.pos, highlight.end, index);
                                                }, 200);
                                            } else if (e.detail === 2) {
                                                e.preventDefault();
                                                jumpHighlight(highlight.pos, highlight.end, index);
                                                await sleep(50);
                                                intoNoteEditStatus(e, index);
                                            }
                                        }}
                                        // onDoubleClick={(e) => {
                                        //     e.stopPropagation();
                                        //     e.preventDefault();
                                        //     intoNoteEditStatus(e, index)
                                        // }}
                                    >{highlight.noteText ? highlight.noteText : t('Add card note')}</div>
                            }
                            </div>
                        </div> :
                        //**********文字-------这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件//这里是第2个条件
                        <div
                            onKeyDown={(event)=>{
                                onKeydown(event)
                            }}
                            draggable={true}

                            onDragEnd={(event) => {
                                const dragData = {
                                    id: highlight.id,
                                    type: 'cardAnno',
                                    x: event.clientX,
                                    y: event.clientY
                                }
                                postMessage(EVENT_TEST_ONDRAG_NOTE, dragData);
                                if(window.location.href.endsWith("/card") || window.location.href.endsWith('/journal') || window.location.href.endsWith('/draw')  || window.location.href.endsWith('/defaultProject')) {
                                    global.g_currentDragLibraryItem = {...highlight,type:dragData.type};
                                }
                            }}
                            id={'card-highlight-'+highlight.id}
                            ref={el => {
                                highlightRefs.current[index] = el
                            }}
                            onClick={() => {
                                // setTimeout(()=>{
                                //     document.activeElement?.blur();
                                // },100)
                                //
                                jumpHighlight(highlight.pos, highlight.end, index)
                            }}
                            key={highlight.listId}
                            class={style.textHighlight}
                            style={{
                                backgroundColor: highlight.selectStatus ? `var(--select-background-color)` : 'var(--dialog-dialog-background-color)',
                                outline: highlight.selectStatus ? '2px solid rgba(161, 179, 228)' : 'none'
                            }}
                            onContextMenu={(e) => moreOptions(e, highlight)}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <span className={'flex-center'} style={{
                                    border: `1.6px solid ${usedColorToShowColor(highlight.color,'#ffd400')}`,
                                    color: usedColorToShowColor(highlight.color,'#ffd400'),
                                    fontSize: '11px',
                                    width:'18px',height:'18px',
                                    fontWeight: '700',
                                    borderRadius:'1.5px'
                                }}>A</span>
                                {
                                    !global.g_isPresentMode &&
                                    <img className={'img-16 cursor-pointer'} src={getImagePathWithTheme('v_more_right')}
                                         onClick={(e) => moreOptions(e, highlight)}/>
                                }
                            </div>
                            <div style={{
                                width: 'calc(100% + 40px)',
                                height: '1px',
                                borderTop: '1px solid var(--line-color)',
                                margin: '8px -20px'
                            }}></div>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <div className={'max-line-8'} style={{
                                    borderLeft: `2px solid ${usedColorToShowColor(highlight.color,'#ffd400')}`,
                                    paddingLeft: '5px',
                                    width: '100%',
                                    fontSize:'12px',
                                    color:'var(--text-color)'
                                }}>{highlight.content}</div>
                            </div>
                            <div style={{marginTop: '12px', color: 'var(--text-color)', fontSize: '14px'}}>{

                               (highlight.editStatus) ?
                                    <TextArea draggable={true} className={'input-white-background input-blue-border'}
                                              style={{resize: 'none',fontSize:'12px',color:'black',
                                                  outline:'none'}}
                                              autoSize={{minRows: 1}}
                                              value={highlight.noteText}
                                              // readOnly={global.g_isPresentMode}
                                              onClick={e => e.stopPropagation()}
                                              onDragStart={(e)=>{
                                                  e.stopPropagation();
                                                  e.preventDefault();
                                              }}
                                              onChange={e => noteTextchange(e, index, highlight)}
                                              onKeyDown={e => exitNoteEditStatus(e, index)}
                                              onBlur={(e)=>{
                                                  //无焦点刷新列表...
                                                  postMessage(EVENT_REFRESH_LIBRARY_LIST);
                                              }}
                                              placeholder={t("Add card note")}/>
                                    :
                                    <div
                                        className={highlight.selectStatus?style.showStatusNoLine:style.showStatus}
                                        style={{height: highlight.noteText ? 'none' : '32px', paddingTop: '5px',color:highlight.noteText?'var(--text-color)':'#9c9c9c'}}
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            if (e.detail === 1) {
                                                setTimeout(() => {
                                                    jumpHighlight(highlight.pos, highlight.end, index);
                                                }, 200);
                                            } else if (e.detail === 2) {
                                                e.preventDefault();
                                                jumpHighlight(highlight.pos, highlight.end, index);
                                                await sleep(50);
                                                intoNoteEditStatus(e, index);
                                            }
                                        }}
                                        // onDoubleClick={(e) => {
                                        //     intoNoteEditStatus(e, index)
                                        // }}
                                    >{(getString(highlight?.noteText) && getString(highlight?.noteText)?.split) ? getString(highlight?.noteText)?.split('\n')?.map((line, i) => (
                                        <Fragment key={i}>
                                            {line}
                                            <br/>
                                        </Fragment>
                                    )) : t('Add card note')}</div>
                            }
                            </div>
                        </div>
                    )
                }
                {
                    highlightContent.length == 0 &&
                    <span style={{color:'var(--text-color)'}}>{t("NoHighlightsYet")}</span>
                }
            </div>

            {
                colorOption.length > 1 &&
                <div className={style.bottomBar}>{
                    colorOption.map((item, index) => <div onClick={(e) => colorChoose(e, item, index)}
                                                          className={style.colorItem} key={item.color} style={{
                        backgroundColor: usedColorToShowColor(item.color),
                        border: item.selectStatus ? '3px solid rgba(0,0,0,0.5)' : 'none',
                        // borderTop:'1px solid var(--line-color)',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}></div>)}
                </div>
            }

        </div>
    )
})
export default HighlightBar